/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("COMMON", "199")




export interface API20869Req {
  
  /**  */
  projectId: string;
    
  /**  */
  ossFile: string;
    
  /** public或private，默认public */
  securityType?: string;
    
};



export interface API20869Res {
  /**   */
  accessToken?: string;
  /**   */
  accessTokenExpiredTime?: string;
  /** 预览地址  */
  previewURL?: string;
  /**   */
  refreshToken?: string;
  /**   */
  refreshTokenExpiredTime?: string;
  /**   */
  requestId?: string;
  
};


// 20869 文档预览接口

export interface IUseGetAPI20869Return {
  /** 文档预览接口: 接口请求状态 */
  isAPI20869Loading: boolean;
  /** 文档预览接口: 接口请求返回数据 */
  dataAPI20869: API20869Res;
  /**  文档预览接口: 接口数据请求方法 */
  fetchAPI20869Data:  (inputs: API20869Req, config?: YWRequestConfig) => Promise<API20869Res>;
  /** 文档预览接口: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI20869 = ():IUseGetAPI20869Return => {
  let isMount = true;
  const [isAPI20869Loading, setIsAPI20869Loading] = useState(false);
  const [dataAPI20869, setDataAPI20869] = useState<API20869Res>({} as API20869Res);
  const requestUrl = `${basePath}/ywwl-generic-base/oss/getOfficePreviewURL`;

  const fetchAPI20869Data = async (inputs: API20869Req, config?: YWRequestConfig): Promise<API20869Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API20869Req>) || {}) as API20869Req;
    
  
    if ( isMount ) {
      setIsAPI20869Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API20869Res>(`${basePath}/ywwl-generic-base/oss/getOfficePreviewURL?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI20869(res || {} as API20869Res);
        setIsAPI20869Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI20869Loading(false);
      }
      return false as unknown as API20869Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI20869Loading,
    dataAPI20869,
    fetchAPI20869Data,
    requestUrl,
  }
}

